import { ScheduleTicker } from "@/lib/app/schedule-ticker";
import { Controler, ControlerEventMap } from "./controler";
import { Track } from "../track";

export abstract class BaseControler implements Controler {
  private listeners = new Map<keyof ControlerEventMap, Set<Function>>();

  on<K extends keyof ControlerEventMap>(
    event: K,
    callback: (data: ControlerEventMap[K]) => void
  ): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
    return () => this.listeners.get(event)?.delete(callback);
  }

  protected emit<K extends keyof ControlerEventMap>(
    event: K,
    data: ControlerEventMap[K]
  ): void {
    this.listeners.get(event)?.forEach(cb => cb(data));
  }

  abstract start(ticker: ScheduleTicker): void;

  destroy(): void {
    this.listeners.clear();
  }
}
